export enum KnmPmActionsEnum {
  KNM_PM_SET_INITIAL_FORM_VALUES = 'KNM_PM_SET_INITIAL_FORM_VALUES',
  KNM_PM_RESET_INITIAL_FORM_VALUES = 'KNM_PM_RESET_INITIAL_FORM_VALUES',
  KNM_PM_TRY_GENERATE_WARNING = 'KNM_PM_TRY_GENERATE_WARNING',

  KNM_PM_GET_PLAN_KNM_SELECT_OPTIONS = 'KNM_PM_GET_PLAN_KNM_SELECT_OPTIONS',
  KNM_PM_SET_PLAN_KNM_SELECT_OPTIONS = 'KNM_PM_SET_PLAN_KNM_SELECT_OPTIONS',

  KNM_PM_OPEN_PLAN_KNM_MESSAGE_MODAL = 'KNM_PM_OPEN_PLAN_KNM_MESSAGE_MODAL',
  KNM_PM_CLOSE_PLAN_KNM_MESSAGE_MODAL = 'KNM_PM_CLOSE_PLAN_KNM_MESSAGE_MODAL',

  KNM_PM_RELOAD_PARTICIPANT_BY_CANCEL = 'KNM_PM_RELOAD_PARTICIPANT_BY_CANCEL',
  KNM_PM_FILL_ORGANIZATIONS_AND_OBJECTS_BY_OTHER_PASSPORT = 'KNM_PM_FILL_ORGANIZATIONS_AND_OBJECTS_BY_OTHER_PASSPORT',
  KNM_PM_SET_CHOOSEN_ORGANIZATION_BY_OTHER_PASSPORT = 'KNM_PM_SET_CHOOSEN_ORGANIZATION_BY_OTHER_PASSPORT',
  PM_SET_OPEN_CHANGE_PM_MODAL = 'PM_SET_OPEN_CHANGE_PM_MODAL',

  KNM_PM_CREATE_FROM_MODAL = 'KNM_PM_CREATE_FROM_MODAL',

  KNM_PM_SET_WAS_FIRST_INIT = 'KNM_PM_SET_WAS_FIRST_INIT',

  KNM_PM_SET_STATUS_HINT_TEXT = 'KNM_SET_STATUS_HINT_TEXT',
  KNM_PM_SET_STATUS_HINT_FIELDS = 'KNM_SET_STATUS_HINT_FIELDS',
}
